export enum DashboardProblemRecordCardsEnum {
  COMPLEX = 'Complex',
  COMPLICATED = 'Complicated',
  SIMPLE = 'Simple',
  CLOSED_CASES = 'ClosedCases',
  ALL = "All"
}

export enum ProblemStatusEnum {
  NEW = 'New',
  OPEN = 'Open',
  UPDATE = 'Update',
  PENDING = 'Pending',
  VERIFY = 'Verify',
}
